export const sortTabsByStatus = (status) => (a, b) =>
  a[`${status}Order`] - b[`${status}Order`];
